import Entity from 'src/app/core/domain/entity';
import UniqueEntityID from 'src/app/core/domain/unique_entity_id';
import { UserId } from 'src/app/data/auth/domain/user';

import { CustomTrackerId } from '../../../dietitian/domain/custom_tracker/custom_tracker';
import { DietitianId } from '../../../dietitian/domain/dietitian';
import { PatientGroupId } from '../../../dietitian/domain/patient_group/patient_group';
import { PatientId } from '../../../patient/domain/patient';
import { TrackerType } from './tracker_type';

export interface TrackerProps {
  dietitianId?: DietitianId;
  patientGroupId?: PatientGroupId;
  patientId?: PatientId;
  patientUserId?: UserId;
  dietitianTrackerId?: CustomTrackerId;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
  diaryType: string;
  type: TrackerType;
  activatedAt?: Date;
  min: number;
  max: number;
  steps?: number | undefined;
  protected: boolean;
  sort: number;
}

export class TrackerId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): TrackerId {
    return new TrackerId(id);
  }
}

export class Tracker extends Entity<TrackerProps> {
  get trackerId(): TrackerId {
    return TrackerId.create(this.id);
  }

  get dietitianId(): DietitianId | undefined {
    return this.props.dietitianId;
  }

  set dietitianId(value: DietitianId | undefined) {
    this.props.dietitianId = value;
  }

  get patientGroupId(): PatientGroupId | undefined {
    return this.props.patientGroupId;
  }

  set patientGroupId(value: PatientGroupId | undefined) {
    this.props.patientGroupId = value;
  }

  get patientId(): PatientId | undefined {
    return this.props.patientId;
  }

  set patientId(value: PatientId | undefined) {
    this.props.patientId = value;
  }

  get dietitianTrackerId(): CustomTrackerId | undefined {
    return this.props.dietitianTrackerId;
  }

  get patientUserId(): UserId | undefined {
    return this.props.patientUserId;
  }

  get createdAt(): Date | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  get name(): string {
    return this.props.name;
  }

  get diaryType(): string {
    return this.props.diaryType;
  }

  get type(): TrackerType {
    return this.props.type;
  }

  get active(): boolean {
    return this.props.activatedAt != undefined;
  }

  get activatedAt(): Date | undefined {
    return this.props.activatedAt;
  }

  set activatedAt(value: Date | undefined) {
    this.props.activatedAt = value;
  }

  get min(): number {
    return this.props.min;
  }

  get max(): number {
    return this.props.max;
  }

  get steps(): number | undefined {
    return this.props.steps;
  }

  get protected(): boolean {
    return this.props.protected;
  }

  set protected(value: boolean) {
    this.props.protected = value;
  }

  get sort(): number {
    return this.props.sort;
  }

  set sort(value: number) {
    this.props.sort = value;
  }

  private constructor(props: TrackerProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: TrackerProps): Tracker {
    return Tracker.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: TrackerProps, id?: UniqueEntityID): Tracker {
    return new Tracker(props, id);
  }
}
